(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('testForm', testForm);

    /* @ngInject */
    function testForm() {
        var directive = {
            bindToController: true,
            templateUrl: 'test-form.tpl',
            controller: testFormController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
                // formData: '=',
                // formFields: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // console.log(scope.formData);
        }

    }

    /* @ngInject */
    function testFormController($scope) {

        $scope.vm.formModel = {};
        $scope.vm.fieldKey = '';
        $scope.vm.fieldPath = '';

        // $scope.vm.testField = function() {
        //     console.log('testField');
        //     $scope.vm.formFields['field-1'] = {
        //         title: 'Field #12',
        //         name: 'field-12',
        //         type: 'number',
        //         label_position: 'after',
        //         descr_position: 'after',
        //         classes: [ 'vpn18', 'vpd9' ],
        //         rules: {
        //             required: true,
        //             min: 0,
        //             max: 100,
        //             step: 10
        //         },
        //         default: 50
        //     };
        //     $scope.vm.formModel['field-1'] = { value:  $scope.vm.formFields['field-1'].default };
        // };

        $scope.vm.formFields = [
            {
                "title": "Text Field",
                "label": "before",
                "name": "text-field",
                "type": "text",
                "classes": ["vpn18", "vpd9"],
                "rules": {
                    "required": false,
                    "limit": 20
                },
                "status": {
                    "error": true,
                    "msg": ["error msg", "error msg 2", "error msg 3"]
                }
            },
            {
                "title": "eMail Field",
                "label": "before",
                "name": "email-field",
                "type": "email",
                "classes": ["vpn18", "vpd9"],
                "rules": {
                    "required": true,
                    "limit": 30
                }
            },
            {
                "title": "Password Field",
                "label": "after",
                "name": "password-field",
                "type": "password",
                "classes": ["vpn18", "vpd9"],
                "rules": {
                    "required": false,
                    "limit": 25
                }
            },
            {
                "title": "Number Field",
                "label": "after",
                "name": "number-field",
                "type": "number",
                "position": "after",
                "classes": ["vpn18", "vpd9"],
                "rules": {
                    "required": true,
                    "min": 0,
                    "max": 100,
                    "step": 10
                },
                "conditions": [
                    {
                        "field": ["choice-field"],
                        "operator": "==",
                        "value": "two"
                    }
                ],
                "default": 50
            },
            {
                "title": "Radio Field",
                "label": "before",
                "name": "radio-field",
                "type": "radio",
                "classes": ["vpn18"],
                "rules": {
                    "required": true
                },
                "choices": [
                    {
                        "title": "One",
                        "value": "one"
                    },
                    {
                        "title": "Two",
                        "value": "two"
                    }
                ],
                "default": "one"
            },
            {
                "title": "Multi-Select",
                "label": "before",
                "name": "multi-select",
                "type": "multi-select",
                "classes": ["vpn18"],
                "rules": {
                    "required": true
                },
                "choices": [
                    {
                        "title": "One",
                        "value": "one"
                    },
                    {
                        "title": "Two",
                        "value": "two"
                    }
                ]
            },
            {
                "title": "Checkbox Field",
                "label": "before",
                "name": "checkbox-field",
                "type": "checkbox",
                "classes": ["vpn18"],
                "rules": {
                    "required": true
                },
                "choices": [
                    {
                        "title": "Check 1",
                        "value": "check1"
                    },
                    {
                        "title": "Check 2",
                        "value": "check2"
                    },
                    {
                        "title": "Check 3",
                        "value": "check3"
                    },
                    {
                        "title": "Check 4",
                        "value": "check4"
                    }
                ],
                "default": ["check2", "check3"]
            },
            {
                "title": "Radio Image Field",
                "label": "before",
                "name": "radio-image-field",
                "type": "radio-img",
                "classes": ["vpn18"],
                "rules": {
                    "required": true
                },
                "choices": [
                    {
                        "title": "One",
                        "image": "http://servings.dev.limusdesign.com/wp-content/themes/servings/img/icons/card.png",
                        "value": "one"
                    },
                    {
                        "title": "Two",
                        "image": "http://servings.dev.limusdesign.com/wp-content/themes/servings/img/icons/daf.png",
                        "value": "two"
                    }
                ],
                "default": "two"
            },
            {
                "title": "Radio Other Field",
                "label": "before",
                "name": "radio-other-field",
                "type": "radio-other",
                "classes": ["vpn18"],
                "placeholder": "Other",
                "rules": {
                    "required": true
                },
                "choices": [
                    {
                        "title": "$500",
                        "value": 500
                    },
                    {
                        "title": "$300",
                        "value": 300
                    },
                    {
                        "title": "$100",
                        "value": 100
                    },
                    {
                        "title": "$30",
                        "value": 30
                    }
                ],
                "default": 100
            },
            {
                "title": "Textarea Field",
                "label": "before",
                "name": "textarea-field",
                "type": "textarea",
                "classes": ["vpn18"],
                "rules": {
                    "placeholder": "enter the text"
                }
            },
            {
                "title": "Repeater Field",
                "label": "before",
                "name": "repeater-field",
                "type": "group",
                "classes": ["vpn18"],
                "repetitive": true,
                "rules": {
                    "required": true,
                    "min": 2,
                    "max": 5
                },
                "fields": [
                    {
                        "title": "Text Field",
                        "name": "text-field",
                        "type": "text",
                        "classes": ["vpn18", "vpd6"],
                        "rules": {
                            "required": false,
                            "limit": 20
                        }
                    },
                    {
                        "title": "Repeater Field",
                        "name": "repeater-field",
                        "type": "group",
                        "classes": ["vpn18", "vpd6"],
                        "repetitive": true,
                        "rules": {
                            "required": false
                        },
                        "fields": [
                            {
                                "title": "Text Field",
                                "name": "text-field",
                                "type": "text",
                                "classes": ["vpn18"],
                                "rules": {
                                    "required": false,
                                    "limit": 20
                                }
                            }
                        ]
                    },
                    {
                        "title": "Number Field",
                        "name": "number-field",
                        "type": "number",
                        "classes": ["vpn18", "vpd6"],
                        "rules": {
                            "required": true,
                            "min": 0,
                            "max": 75,
                            "step": 5
                        },
                        "default": 50
                    }
                ]
            },
            {
                "title": "Tabs",
                "label": "before",
                "name": "tabs",
                "type": "multigroup",
                "sequential": true,
                "submit-on-last": true,
                "submit-title": "send",
                "next-title": "next",
                "prev-title": "back",
                "classes": ["vpn18"],
                "fields": [
                    {
                        "title": "Tab 1",
                        "name": "tab1",
                        "type": "group",
                        "classes": ["vpn18"],
                        "fields": [
                            {
                                "title": "Text Field",
                                "name": "text-field",
                                "type": "text",
                                "classes": ["vpn18", "vpd9"],
                                "rules": {
                                    "required": false,
                                    "limit": 20
                                }
                            },
                            {
                                "title": "Number Field",
                                "name": "number-field",
                                "type": "number",
                                "classes": ["vpn18", "vpd9"],
                                "rules": {
                                    "required": true,
                                    "min": 0,
                                    "max": 75,
                                    "step": 25
                                },
                                "default": 75
                            }
                        ]
                    },
                    {
                        "title": "Tab 2",
                        "name": "tab2",
                        "type": "group",
                        "classes": ["vpn18"],
                        "fields": [
                            {
                                "title": "Number Field",
                                "name": "number-field",
                                "type": "number",
                                "classes": ["vpn18", "vpd6"],
                                "rules": {
                                    "required": true,
                                    "min": 0,
                                    "max": 99,
                                    "step": 33
                                },
                                "default": 66
                            },
                            {
                                "title": "Select Field",
                                "name": "select-field",
                                "type": "select",
                                "classes": ["vpn9", "vpd6"],
                                "rules": {
                                    "required": true,
                                    "multiple": false
                                },
                                "choices": [
                                    {
                                        "title": "Select 1",
                                        "value": "select1"
                                    },
                                    {
                                        "title": "Select 2",
                                        "value": "select2"
                                    },
                                    {
                                        "title": "Select 3",
                                        "value": "select3"
                                    },
                                    {
                                        "title": "Select 4",
                                        "value": "select4"
                                    }
                                ],
                                "default": "select3"
                            },
                            {
                                "title": "Repeater Field",
                                "name": "repeater-field",
                                "type": "group",
                                "classes": ["vpn9", "vpd6"],
                                "repetitive": true,
                                "rules": {
                                    "required": false
                                },
                                "fields": [
                                    {
                                        "title": "Text Field",
                                        "name": "text-field",
                                        "type": "text",
                                        "classes": ["vpn18"],
                                        "rules": {
                                            "required": false,
                                            "limit": 20
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];

        /*
        $scope.vm.formFields = {
            'field-1': {
                title: 'Field #1',
                description: 'text field one',
                descr_position: 'after',
                name: 'field-1',
                type: 'text',
                classes: [ 'vpn18', 'vpd9' ],
                rules: {
                    required: false,
                    limit: 20
                }
            },
            'email-1': {
                title: 'email #1',
                name: 'email-1',
                type: 'email',
                classes: [ 'vpn18', 'vpd9' ],
                rules: {
                    required: false,
                    limit: 30
                }
            },
            'password-1': {
                title: 'password #1',
                name: 'password-1',
                type: 'password',
                classes: [ 'vpn18', 'vpd9' ],
                rules: {
                    required: false,
                    limit: 25
                }
            },
            'field-2': {
                title: 'Field #2',
                name: 'field-2',
                type: 'number',
                label_position: 'after',
                classes: [ 'vpn18', 'vpd9' ],
                rules: {
                    required: true,
                    min: 0,
                    max: 100,
                    step: 10
                },
                conditions: [
                    {
                        field: ['choice-3'],
                        operator: '==',
                        value: 'two'
                    }
                ],
                default: 50
            },
            'radio-img': {
                title: 'radio-img',
                name: 'radio-img',
                type: 'radio-img',
                classes: [ 'vpn18' ],
                rules: {
                    required: true
                },
                choices: [
                    {
                        title: 'One',
                        image: 'http://servings.dev.limusdesign.com/wp-content/themes/servings/img/icons/card.png',
                        value: 'one'
                    },
                    {
                        title: 'Two',
                        image: 'http://servings.dev.limusdesign.com/wp-content/themes/servings/img/icons/daf.png',
                        value: 'two'
                    }
                ]
            },
            'radio-other': {
                title: 'radio-other',
                name: 'radio-other',
                type: 'radio-other',
                classes: [ 'vpn18' ],
                placeholder: 'Other',
                rules: {
                    required: true
                },
                choices: [
                    {
                        title: '$500',
                        value: '500'
                    },
                    {
                        title: '$300',
                        value: '300'
                    },
                    {
                        title: '$100',
                        value: '100'
                    },
                    {
                        title: '$30',
                        value: '30'
                    }
                ]
            },
            'choice-3': {
                title: 'Choice #3',
                name: 'choice-3',
                type: 'radio',
                classes: [ 'vpn18' ],
                rules: {
                    required: true
                },
                choices: [
                    {
                        title: 'One',
                        value: 'one'
                    },
                    {
                        title: 'Two',
                        value: 'two'
                    }
                ],
                default: 'one'
            },
            'check-3': {
                title: 'check #3',
                name: 'check-3',
                type: 'checkbox',
                classes: [ 'vpn18' ],
                rules: {
                    required: true
                },
                choices: [
                    {
                        title: 'check-1',
                        value: 'check1'
                    },
                    {
                        title: 'check-2',
                        value: 'check2'
                    },
                    {
                        title: 'check-3',
                        value: 'check3'
                    },
                    {
                        title: 'check-4',
                        value: 'check4'
                    }
                ],
                default: ['check2', 'check3']
            },
            'select-multiple-1': {
                title: 'select-multiple #1',
                name: 'select-multiple-1',
                description: 'select multiple',
                type: 'select',
                classes: [ 'vpn18', 'vpd9' ],
                rules: {
                    required: true,
                    multiple: true
                },
                choices: [
                    {
                        title: 'multiple-1',
                        value: 'multiple1'
                    },
                    {
                        title: 'multiple-2',
                        value: 'multiple2'
                    },
                    {
                        title: 'multiple-3',
                        value: 'multiple3'
                    },
                    {
                        title: 'multiple-4',
                        value: 'multiple4'
                    },
                    {
                        title: 'multiple-5',
                        value: 'multiple5'
                    },
                    {
                        title: 'multiple-5',
                        value: 'multiple5'
                    }
                ],
                default: 'multiple4'
            },
            'tags-input': {
                title: 'tags-input',
                name: 'tags-input',
                description: 'tags-input',
                type: 'tags-input',
                placeholder: 'Add a tag',
                classes: [ 'vpn18', 'vpd9' ],
                choices: [
                    {
                        title: 'multiple-1',
                        value: 'multiple1'
                    },
                    {
                        title: 'multiple-2',
                        value: 'multiple2'
                    },
                    {
                        title: 'multiple-3',
                        value: 'multiple3'
                    },
                    {
                        title: 'multiple-4',
                        value: 'multiple4'
                    },
                    {
                        title: 'multiple-5',
                        value: 'multiple5'
                    },
                    {
                        title: 'multiple-6',
                        value: 'multiple6'
                    }
                ]
            },
            'textarea-3': {
                title: 'Textarea #3',
                name: 'textarea-3',
                description: 'enter the text into the area',
                descr_position: 'after',
                type: 'textarea',
                classes: [ 'vpn18' ],
                rules: {
                    placeholder: 'enter the text'
                }
            },
            'repeater-1': {
                title: 'Repeater #1',
                name: 'repeater-1',
                type: 'group',
                classes: [ 'vpn18' ],
                repetitive: true,
                rules: {
                    required: true,
                    min: 2,
                    max: 5
                },
                fields: {
                    'field-1': {
                        title: 'Field #1',
                        name: 'field-1',
                        type: 'text',
                        classes: [ 'vpn18', 'vpd6' ],
                        rules: {
                            required: false,
                            limit: 20
                        }
                    },
                    'rep-1-1': {
                        title: 'Repeater -1-1',
                        name: 'rep-1-1',
                        type: 'group',
                        classes: [ 'vpn18', 'vpd6' ],
                        repetitive: true,
                        rules: {
                            required: false
                        },
                        fields: {
                            'r-t-1-1': {
                                title: 'r-t-1-1',
                                name: 'r-t-1-1',
                                type: 'text',
                                classes: [ 'vpn18' ],
                                rules: {
                                    required: false,
                                    limit: 20
                                }
                            }
                        }
                    },
                    'field-2': {
                        title: 'Field #2',
                        name: 'field-2',
                        type: 'number',
                        classes: [ 'vpn18', 'vpd6' ],
                        rules: {
                            required: true,
                            min: 0,
                            max: 100,
                            step: 20
                        },
                        default: 100
                    }
                }
            },
            'tabs': {
                title: 'Tabs',
                name: 'tabs',
                type: 'multigroup',
                sequential: true,
                'submit-on-last': true,
                'submit-title': 'send',
                'next-title': 'next',
                'prev-title': 'back',
                classes: [ 'vpn18' ],
                fields: {
                    'tab1': {
                        title: 'Tab 1',
                        name: 'tab1',
                        type: 'group',
                        classes: [ 'vpn18' ],
                        fields: {
                            'field-1': {
                                title: 'Field #1',
                                name: 'field-1',
                                type: 'text',
                                classes: [ 'vpn18', 'vpd9' ],
                                rules: {
                                    required: false,
                                    limit: 20
                                }
                            },
                            'field-2': {
                                title: 'Field #2',
                                name: 'field-2',
                                type: 'number',
                                classes: [ 'vpn18', 'vpd9' ],
                                rules: {
                                    required: true,
                                    min: 0,
                                    max: 100,
                                    step: 20
                                },
                                default: 100
                            }
                        }
                    },
                    'tab2': {
                        title: 'Tab 2',
                        name: 'tab2',
                        type: 'group',
                        classes: [ 'vpn18' ],
                        fields: {
                            'field-3': {
                                title: 'Field #3',
                                name: 'field-3',
                                type: 'text',
                                classes: [ 'vpn18' ],
                                rules: {
                                    required: false,
                                    limit: 20
                                }
                            },
                            'repeater-1': {
                                title: 'Repeater #1',
                                name: 'repeater-1',
                                type: 'group',
                                classes: [ 'vpn18' ],
                                repetitive: true,
                                rules: {
                                    required: true,
                                    min: 2,
                                    max: 5
                                },
                                fields: {
                                    'field-1': {
                                        title: 'Field #1',
                                        name: 'field-1',
                                        type: 'text',
                                        classes: [ 'vpn18', 'vpd6' ],
                                        rules: {
                                            required: false,
                                            limit: 20
                                        }
                                    },
                                    'field-2': {
                                        title: 'Field #2',
                                        name: 'field-2',
                                        type: 'number',
                                        classes: [ 'vpn18', 'vpd6' ],
                                        rules: {
                                            required: true,
                                            min: 0,
                                            max: 100,
                                            step: 20
                                        },
                                        default: 100
                                    },
                                    'select-1': {
                                        title: 'select #1',
                                        name: 'select-1',
                                        type: 'select',
                                        classes: [ 'vpn18', 'vpd6' ],
                                        rules: {
                                            required: true,
                                            multiple: false
                                        },
                                        choices: [
                                            {
                                                title: 'select-1',
                                                value: 'select1'
                                            },
                                            {
                                                title: 'select-2',
                                                value: 'select2'
                                            },
                                            {
                                                title: 'select-3',
                                                value: 'select3'
                                            },
                                            {
                                                title: 'select-4',
                                                value: 'select4'
                                            }
                                        ],
                                        default: 'select3'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
        */

    }
})();